import { message } from 'antd'
import { deleteTimesheet } from '../../../HttpRequests/timesheets'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async () => {

  const { id, onClose, didDelete } = getProps()

  try {

    await deleteTimesheet({ id })

    message.success('Timesheet Deleted')

    onClose()

    if (didDelete) didDelete()

  } catch (error) {

    handleException(error)

  }

}
